import { fetchPrivateApi } from '@/lib/api/apiServiceBase.ts';
import { TourInsurancesDto } from '@/features/dashboard/tourInsurances/types/TourInsurancesDto.ts';
import { TourInsuranceAssignmentRequest } from '@/features/dashboard/tourInsurances/types/TourInsuranceAssignmentRequest.ts';

const tourInsurancesApi = {
  get: async (tourId: string): Promise<TourInsurancesDto> => {
    return await fetchPrivateApi<TourInsurancesDto>(
      'GET',
      `tours/${tourId}/insurances`,
    );
  },
  put: async (
    tourId: string,
    request: TourInsuranceAssignmentRequest,
  ): Promise<TourInsurancesDto> => {
    return await fetchPrivateApi<TourInsurancesDto>(
      'PUT',
      `tours/${tourId}/insurances`,
      request,
    );
  },
};

export default tourInsurancesApi;
